import * as React from 'react'

export const SuperAdminInfo = (props: any) => {
    var superAdmin = true;
    var [showDialog,setShowDialog] = React.useState(false);
    var isLookup = props.dataSource && props.dataSource.startsWith("/lookup/lookupname/") || false;
    var tip = '';

    tip += '---------- Super Admin Info ----------' + '\n';
    if (props.id) tip += 'Id : ' + (props.id || '') + '\n';
    if (props.name) tip += 'Name : ' + (props.name || '') + '\n';
    if (props.securityObject) tip += 'Security Object : ' + (props.securityObject || '') + '\n';
    if (props.table) tip += 'Table : ' + (props.table || '') + '\n';
    if (props.schema) tip += 'Schema : ' + (props.schema || '') + '\n';
    if (props.dataSource) {
        tip += isLookup
            ? ("Lookup Name: " + props.dataSource.replace("/lookup/lookupname/", ""))
            : ("Dropdown Source: " + props.dataSource)
    }

    return <>
        {superAdmin
            ? <span onDoubleClick={() => onRedirect(props)} className={(isLookup ? "label-infocus-admin" : "")} title={tip} onClick={() => setShowDialog(true)}>{props.label}</span>
            : <span>{props.label}</span>}
    </>
}